import React, { Suspense, useContext, useEffect } from 'react';
import './App.css';
import CandidateLayout from './layouts/CandidateLayout';
import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter, Route } from 'react-router-dom';
import { Spin } from 'antd';
import CandidateLogin from './pages/CandidateLogin';
import AuthContext from './store/AuthContext'
import { DataProvider } from './store/DataContext';

const spin_load = () => {
  return (
    <div className={"pageLoader"} style={{ display: "flex", justifyContent: "center", height: "100vh", alignItems: "center" }}>
      <center>
        <Spin size="large" tip="loading..."></Spin>
      </center>
    </div>)
}

function App() {
  const ctx = useContext(AuthContext);

  return (
    <DataProvider>
      <BrowserRouter>
        <Suspense fallback={spin_load()}>
          <CandidateLayout />
          {/* <div className='bg'>
          {!ctx.isLoggedIn && <CandidateLogin />}
        </div> */}
        </Suspense>
      </BrowserRouter>
    </DataProvider>
  );
}

export default App;
